export enum Module {
  Oxygen = 1,
  Fluorescence = 2,
  LiquidControl = 3,
  Sparging = 4,
  BaseModule = 5,
  pH = 6,
  PHBuffer = 7,
}
